import React, { useState  ,useContext } from "react";
import { Link } from "react-router-dom";
import { APPNAME, BACKEND_URL  , AuthContext } from './util/api';

import logoImg from "./logo.jpeg"; // <-- ADD YOUR LOGO HERE

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const{token , logout ,  info}  = useContext(AuthContext);

  // SINGLE MENU MAP FOR DESKTOP & MOBILE
/*   const menuItems = [
    { label: "Home", path: "/" },

    { label: "Gallery", path: "/gallery" },
    { label: "Executives", path: "/excos" },
    { label: "Members", path: "/members" },
    { label: "Newsletter", path: "/newsletter" },
    { label: "Dashboard", path: "/dashboard" },
     
            { label: "Register", path: "/register" },
            { label: "Login", path: "/login" },
         
     
        { label: "Logout", path: "/logout" },
  ]; */



  const commonItems = [
    { label: "Home", path: "/" },

       { label: "Sermon", path: "/sermon" },
     { label: "Articles", path: "/news" },
   
    { label: "Gallery", path: "/gallery" },
    { label: "Excos", path: "/excos" },
  
   
  ];

  const authItems = token
    ? [
        { label: "Members", path: "/members" }, 
        { label: "Dashboard", path: "/dashboard" },
         
        { label: "Logout", path: "/logout" },
      ]
    : [
        { label: "Register", path: "/register" },
        { label: "Login", path: "/login" },
      ];

  const menuItems = [...commonItems, ...authItems];



  

  return (
    <>
    {  info !=  null  &&
      <nav style={styles.navbar} role="navigation" aria-label="Main navigation">
        
        {/* BRAND WITH LOGO */}
        <div style={styles.brandWrap}>
          <img
            src={BACKEND_URL + "/picture_logo/logo.png"}
            alt="Logo"
            style={styles.logoImg}
          />
          <div style={styles.logoTextWrap}>
            <div style={styles.logo}>{ info.org_name != null ? info.org_name : " " }</div>
           {/*  <div style={styles.tag}>Ado Ekiti</div> */}
          </div>
        </div>

          
        {/* DESKTOP LINKS */}
        <ul style={styles.desktopLinks} className="navDesktop" aria-hidden={false}>
          {menuItems.map((item, idx) => (
            <li key={idx} style={styles.navItem}>
              {item.path === "/logout" ? (
                <button
                  onClick={() => {
                    logout();
                    setMenuOpen(false);
                  }}
                  style={{ ...styles.navItem, background: "transparent", border: "none" }}
                >
                  {item.label}
                </button>
              ) : (
                <Link style={styles.navItem} to={item.path}>
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>

        {/* ACTIONS  MOBILE TOGGLE */}
        <div style={styles.actions}>
          <div
            style={styles.menuIcon}
            className="navMobileToggle"
            onClick={() => setMenuOpen((s) => !s)}
            aria-expanded={menuOpen}
            aria-label="Toggle menu"
          >
            <span style={{ fontSize: 20 }}>{menuOpen ? "✕" : "☰"}</span>
          </div>
        </div>

        {/* MOBILE PANEL */}
        <div
          className={`mobilePanel ${menuOpen ? "open" : "closed"}`}
          style={{ ...styles.mobilePanel, top: 74 }}
          role="menu"
        >
            <ul style={styles.mobileLinks}>
            {menuItems.map((item, idx) => (
              <li key={idx} style={styles.mobileItem}>
                {item.path === "/logout" ? (
                  <button
                    onClick={() => {
                      logout();
                      setMenuOpen(false);
                    }}
                    style={{ ...styles.mobileItem, background: "transparent", border: "none", textAlign: "left", width: "100%" }}
                  >
                    {item.label}
                  </button>
                ) : (
                  <Link
                    style={styles.mobileItem}
                    to={item.path}
                    onClick={() => setMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>


        </div>
      </nav>

          }
    </>
  );
};

const styles = {
  /* NAVBAR */
  navbar: {
    position: "fixed",
    top: 12,
    left: 12,
    right: 12,
    zIndex: 3000,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 18px",
    borderRadius: 14,
    background: "linear-gradient(180deg, rgba(255,255,255,0.6), rgba(255,255,255,0.26))",
    boxShadow: "0 12px 40px rgba(6,18,28,0.08)",
    backdropFilter: "blur(10px) saturate(110%)",
    border: "1px solid rgba(255,255,255,0.6)",
  },

  /* LOGO AREA */
  brandWrap: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },

  logoImg: {
    width: 40,
    height: 40,
    objectFit: "cover",
    borderRadius: "50%",
    border: "2px solid rgba(255,255,255,0.7)",
  },

  logoTextWrap: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
  },

  logo: {
    fontWeight: 900,
    fontSize: 18,
    color: "#062834",
  },

  tag: {
    fontSize: 11,
    color: "#0A3D62",
    opacity: 0.8,
    fontWeight: 700,
  },

  /* DESKTOP LINKS */
  desktopLinks: {
    display: "flex",
    gap: 24,
    alignItems: "center",
    listStyle: "none",
    margin: 0,
    padding: 0,
  },

  navItem: {
    fontWeight: 700,
    fontSize: 15,
    color: "#0A3D62",
    cursor: "pointer",
    padding: "8px 10px",
    borderRadius: 10,
    transition: "all 180ms ease",
  },

  /* ACTIONS */
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  menuIcon: {
    display: "block",
    padding: "8px 10px",
    borderRadius: 10,
    cursor: "pointer",
    marginLeft: 6,
    background: "rgba(255,255,255,0.35)",
    border: "1px solid rgba(255,255,255,0.5)",
    boxShadow: "0 8px 18px rgba(8,22,34,0.06)",
  },

  /* MOBILE PANEL */
  mobilePanel: {
    position: "fixed",
    right: 12,
    zIndex: 2500,
    width: 260,
    background: "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(248,252,255,0.95))",
    borderRadius: 12,
    boxShadow: "0 20px 60px rgba(4,14,30,0.12)",
    padding: 18,
  },

  mobileLinks: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },

  mobileItem: {
    padding: "10px 12px",
    borderRadius: 8,
    fontWeight: 800,
    color: "#08324A",
    cursor: "pointer",
  },
};

export default Navbar;